import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DateComponentSettings from './DateComponent_Settings';
import DateComponentCurrencySettings from './DateComponent_CurrencySettings';
import query from '../../helpers/query';
import DataComponentBodyPaymentAccounts from "./DataComponent__BodyPaymentAccounts";

const DataComponentPaymentAccounts = ({
    isQuery,
    loading,
    page,
    alignPagination,
    settings,
    fields,
    className,
    settingKey,
    columnData,
    displayControl,
    hidden,
    headerNames,
    tableBodyTitle,
    currencySettings,
    currencySettingKey,
    currencySettingData,
    data,
    multiLevelHeaderNames,
    totalPages,
    onAction
}) => {
    const [state, setState] = useState({
        filters: {},
        typeDisplayControl: 'table',
        page: page
    });

    const onActionHandler = useCallback((type) => {
        const actionState = {
            ...state.filters
        };

        onAction(actionState, type);

        if (isQuery) {
            query.replace(actionState);
        }
    }, [state.filters, onAction, isQuery]);

    const onPageChange = useCallback((page) => {
        setState(prev => ({
            ...prev,
            filters: {
                ...prev.filters,
                page
            }
        }));
        onActionHandler('pageChange');
    }, [onActionHandler]);

    const onFiltersApply = useCallback((state, type = 'filtersChange') => {
        setState(prev => ({
            ...prev,
            filters: {
                ...state
            }
        }));
        onActionHandler(type);
    }, [onActionHandler]);

    const onDisplayControlChange = useCallback((type) => {
        setState(prev => ({
            ...prev,
            typeDisplayControl: type
        }));
    }, []);

    const getClassFooter = useCallback(() => {
        return classNames({
            'ibox-footer': true,
            'text-right': alignPagination
        });
    }, [alignPagination]);

    useEffect(() => {
        setState(prev => ({
            ...prev,
            page: page || prev.page
        }));
    }, [page]);

    useEffect(() => {
        if (!fields.length) {
            onActionHandler('firstRender');
        }
    }, [fields.length, onActionHandler]);

    return (
        <div className="ibox">
            <DateComponentSettings 
                settings={settings}
                headerNames={headerNames}
                tableBodyTitle={tableBodyTitle}
                settingKey={settingKey}
                loading={loading}
                data={data}
                filters={state.filters}
            />
            <DateComponentCurrencySettings
                settings={currencySettings}
                headerNames={headerNames}
                tableBodyTitle={tableBodyTitle}
                settingKey={currencySettingKey}
                loading={loading}
                data={currencySettingData}
                filters={state.filters}
            />
            <div className="ibox-content">
                <DataComponentBodyPaymentAccounts
                    data={data}
                    headerNames={headerNames}
                    multiLevelHeaderNames={multiLevelHeaderNames}
                    columnData={columnData}
                    loading={loading}
                    settings={settings}
                    settingKey={settingKey}
                    displayControl={{
                        ...displayControl,
                        type: state.typeDisplayControl
                    }}
                    filters={state.filters}
                    className={className}
                />
            </div>
        </div>
    );
};

DataComponentPaymentAccounts.propTypes = {
    isQuery: PropTypes.bool,
    loading: PropTypes.bool,
    page: PropTypes.number,
    alignPagination: PropTypes.bool,
    settings: PropTypes.bool,
    fields: PropTypes.array,
    className: PropTypes.string,
    settingKey: PropTypes.string,
    columnData: PropTypes.shape({
        header: PropTypes.object,
        body: PropTypes.object
    }),
    displayControl: PropTypes.shape({
        type: PropTypes.string,
        name: PropTypes.string,
        data: PropTypes.array
    }),
    hidden: PropTypes.bool,
    headerNames: PropTypes.array,
    tableBodyTitle: PropTypes.string,
    currencySettings: PropTypes.bool,
    currencySettingKey: PropTypes.string,
    currencySettingData: PropTypes.array,
    data: PropTypes.array,
    multiLevelHeaderNames: PropTypes.array,
    totalPages: PropTypes.number,
    onAction: PropTypes.func
};

DataComponentPaymentAccounts.defaultProps = {
    isQuery: false,
    loading: false,
    page: 1,
    alignPagination: false,
    settings: false,
    fields: [],
    className: '',
    settingKey: '',
    columnData: {
        header: {},
        body: {}
    },
    displayControl: null,
    hidden: false,
    headerNames: [],
    tableBodyTitle: '',
    currencySettings: false,
    currencySettingKey: '',
    currencySettingData: [],
    data: [],
    multiLevelHeaderNames: [],
    totalPages: 0,
    onAction: () => {}
};

export default DataComponentPaymentAccounts;
